export default "__VITE_ASSET__s_fw5LI9__"